import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {LoginComponent} from '@core/modules/authentication/components';
import {LOGIN_ROUTE_MODULE} from '@core/constants/navigation/navigation.const';

export const routes: Routes = [
  {
    path: '',
    redirectTo: LOGIN_ROUTE_MODULE,
    pathMatch: 'full'
  },
  {
    path: LOGIN_ROUTE_MODULE,
    component: LoginComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule {}
